import React from 'react';

const IconAdmin = ({ className }) => (
  <svg className={className} width='23' height='22' viewBox='0 0 23 22' xmlns='http://www.w3.org/2000/svg'>
    <path d='M22.11 17.99L13.03 8.91C13.96 6.57 13.48 3.81 11.59 1.91C9.28996 -0.389998 5.70996 -0.599998 3.15996 1.26L6.99996 5.11L5.57996 6.52L1.74996 2.69C-0.110039 5.23 0.0999615 8.82 2.39996 11.11C4.25996 12.97 6.96996 13.46 9.28996 12.59L18.4 21.7C18.79 22.09 19.42 22.09 19.81 21.7L22.11 19.4C22.51 19.02 22.51 18.39 22.11 17.99ZM19.11 19.59L9.64996 10.13C9.03996 10.58 8.35996 10.85 7.64996 10.95C6.28996 11.15 4.85996 10.74 3.81996 9.7C2.86996 8.76 2.42996 7.5 2.49996 6.26L5.58996 9.35L9.82996 5.11L6.73996 2.02C7.97996 1.95 9.22996 2.39 10.18 3.33C11.26 4.41 11.67 5.9 11.42 7.29C11.3 8 11 8.66 10.54 9.25L19.99 18.7L19.11 19.59Z' />
  </svg>
);

export default IconAdmin;
